import $ from 'jquery'
import 'jquery-validation'
import 'jquery-validation-unobtrusive'
import 'jquery-ajax-unobtrusive'
import '@lib/forms/form.validate'
import logger from '@plugins/logger'
import { mapMutations, mapState } from 'vuex'
import InputsMixin from './inputs'
import TrackingMixin from './forms-tracking-mixin'
import ErrorsMixin from './forms-errors-mixin'
import ValidationMixin from './forms-validation-mixin'
import SitecoreMixin from './forms-sitecore-editor-mixin'
import RenderMixin from './forms-render-mixin'

/**
 * Base implementation form all the forms
 */
export default ({
  name,
  submitType,
  dataType,
  errorHandling,
  tracking = {},
  submitOnChange = false,
  skipValidation = false,
  nativeSubmit = false,
}) => {
  const required = [submitType, dataType, errorHandling]
  if (required.includes(undefined)) {
    const error = new Error('Missing required parameter')
    logger.error(error)
    throw error
  }
  return {
    mixins: [
      InputsMixin,
      TrackingMixin({ name, tracking }),
      ErrorsMixin({ errorHandling }),
      ValidationMixin({ skipValidation }),
      SitecoreMixin,
      RenderMixin,
      dataType,
      submitType
    ],
    data: () => ({
      isMounted: false,
      isLoading: false,
      form: null,
    }),
    computed: {
      ...mapState('booking', ['checkOutPending']),
      submitOnChange() {
        if (this.submitOnChangeOveride) {
          return !this.submitOnChangeOveride
        }
        return submitOnChange
      }
    },
    watch: {
      isLoading(val) {
        this.$emit('loading', val)
      }
    },
    mounted() {
      this.isMounted = true
      this.form = this.$el.tagName === 'FORM' ? $(this.$el) : $(this.$el).find('form')
      this.parsedFormUrl = new URL(window.location.href)
      this.parseValidation()
      this.initForm()
    },
    beforeDestroy() {
      this.destroyConditions()
    },
    methods: {
      ...mapMutations('booking', ['CHECK_OUT_PENDING']),
      getSelector() {
        const classes = this.form.attr('class').split(' ').join('.')
        const id = this.form.attr('id')
        return `form${id ? `#${id}` : ''}.${classes}`
      },
      initForm() {
        this.trackView()
        this.form.on('submit', this.onSubmit)
        this.initInputs()
        if (this.submitOnChange) {
          this.bindChangeEvent()
        }
        this.initConditions()
      },
      reInitForm() {
        this.reInitInputs()
        this.form.removeData('validator')
          .removeData('unobtrusiveValidation')
        $.validator.unobtrusive.parse(this.form)
      },
      async onSubmit(e) {
        if (!nativeSubmit && !this.isHsia) {
          e.preventDefault()
        }

        this.clearErrors()
        try {
          await this.validateForm()
          if (nativeSubmit || this.isHsia) {
            return true
          }
          this.isLoading = true
          let data = await this.serializeData()
          if (typeof this.transformData === 'function') {
            data = await this.transformData(data)
          }
          const response = await this.submitAction(data)
          const isProfileForm = e.currentTarget.closest('.profile-form')
          if (!isProfileForm) this.trackSubmit(response)
          await this.onResponse(response, data)
        } catch (error) {
          this.$emit('error', error)
          this.handleErrors(error)
          if (this.checkOutPending) {
            this.CHECK_OUT_PENDING(false)
          }
          if (nativeSubmit || this.isHsia) {
            return false
          }
        }
        this.isLoading = false
      },
      async onResponse(response, data) {
        if (typeof this.transformResponse === 'function') {
          response = await this.transformResponse(response, data)
        }
        this.$emit('response', response)
      },
      bindChangeEvent() {
        this.inputs.forEach((inputObj) => {
          inputObj.el.on('change', () => this.form.submit())
        })
      }
    },
  }
}
